/* eslint-disable filenames/match-regex */
export interface ICmsBlock {
	id: string;
	componentName: string;
	isContainer: string;
	slots: string[];
	placeholders: string;
	props: {
		values: unknown;
		cfgs: unknown;
		extras: unknown;
	};
}

export interface IContentLayout {
	id?: string;
	componentName: string | null;
	props: unknown[];
}

export interface IContentData {
	layout: IContentLayout | null;
	placeholders: {
		content: unknown[];
	};
}

class CmsBlock implements ICmsBlock {
	public id: string;
	public componentName: string;
	public isContainer: string;
	public slots: string[];
	public placeholders: string;
	public props: {
		values: unknown;
		cfgs: unknown;
		extras: unknown;
	};

	constructor(data: any) {
		this.id = data.id;
		this.componentName = data.block_name;
		this.isContainer = data.is_container;
		this.slots = data.placeholders ? Object.keys(data.placeholders) : [];
		this.placeholders = data.placeholders;
		this.props = {
			values: data.values,
			cfgs: data.cfgs,
			extras: data.extras,
		};
	}
}

export const extractBlocks = (blocks: any[]): ICmsBlock[] => blocks.map((b) => new CmsBlock(b));

export const extractLayout = (contentData: IContentData): IContentLayout => {
	const layout: IContentLayout = {
		componentName: null,
		props: [],
	};

	if (contentData.layout) {
		layout.componentName = `Layout${contentData.layout.id}`;
		layout.props = contentData.placeholders.content;
	}
	return layout;
};
